
<div fxLayout="row" fxLayoutAlign="space-between center" >
  <h5 mat-dialog-title class="header">
    Please select account
  </h5>
  <button matTooltip="Logout" mat-button mat-dialog-close (click)="onLogOutClick()" color="warn"><i class="bi bi-box-arrow-in-right text-danger fa-2x"></i></button>
</div>
<div mat-dialog-content class="pb-5 pt-5">
  <ng-container *ngIf="options.length > 0">
    <mat-card *ngFor="let option of options" [ngClass]="{'selected': option.id === selectedOption}" (click)="selectOption(option.id)">
      <mat-card-content>
        <mat-radio-button color="primary" [checked]="option.id == selectedOption"></mat-radio-button>
        {{ option.storeName | titlecase }}
        <span *ngIf="option.merchantType == merchantTypeEnum.HqMerchant"
              class="badge badge-pill badge-info ml-2">HQ</span>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <ng-container *ngIf="options.length == 0">
    <p class="text-danger small">* We apologize, but you currently do not have access to any merchant account.</p>
  </ng-container>

</div>
<div class="footer p-2">
  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-button mat-dialog-close (click)="onCloseClick()" color="warn" class="mr-2" *ngIf="isMerchantChose">
      <i class="bi bi-x-circle mr-1"></i>
      Close
    </button>
    <button mat-flat-button mat-dialog-close cdkFocusInitial (click)="onConfirmClick()" color="primary" [disabled]="disableConfirm">
      <i class="bi bi-check-circle mr-1"></i>
      Confirm
    </button>
  </div>
</div>
